import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaHome,FaUser, FaSearch } from "react-icons/fa"; 
import '../BottomNavigation.css';
import AuthModal from "../Modals/AuthModals";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const [authmodals, setAuthModals] = useState(false);

  useEffect(() => {
    const userData = localStorage.getItem("USER_DATA");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);


  return (
    <>
      <div className="bottom-nav">
        <Link to="/" className="nav-item">
          <FaHome className="nav-icon" />
          <span>Home</span>
        </Link>

        
          <Link to="/" className="nav-item">
            <FaSearch className="nav-icon" />
            <span>Explore</span>
          </Link>

        {user ? (
          <Link to="/" className="nav-item">
            <FaUser className="nav-icon" />
            <span>Account</span>

          </Link>
        ) : (
          <button
            className="nav-item"
            onClick={() => setAuthModals(true)}
          >
            <FaUser className="nav-icon" />
            <span>Account</span>

          </button>
        )}


      </div>
      <AuthModal show={authmodals} handleClose={() => setAuthModals(false)} />
    </>

  );
};

export default BottomNavigation;
